import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { GetUserSubServicesDataTypes } from "../../../../Schema/getUserSubServices.types";
import { ServiceFileValidationDataTypes } from "../../../../Schema/serviceFileValidation.types";

export type GetUserSubServicesLoadAction = {
  type: string;
  payload: { id: number | string };
};

export type GetUserSubServicesData = {
  data: {
    user_service_files: {
      id: number;
      file_path: string;
      pivot: {
        service_id: number;
        file_id: number;
      };
    }[];
    sub_services: GetUserSubServicesDataTypes[];
    file_validation_res: ServiceFileValidationDataTypes;
    short_info: string[];
    all_in_one_purchase_ability: number;
  };
};

const GetUserSubServices = new ReduxFetchState<
  GetUserSubServicesData,
  { id: number | string },
  any
>("getUserSubServices");

export function* watchGetUserSubServices(action: GetUserSubServicesLoadAction) {
  try {
    const { id } = action.payload;
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: GetUserSubServicesData = yield axios({
      url: `/api/v1/ai/user-sub-services/${id}/show`,
      method: "GET",
      headers: {
        lang,
      },
    });

    yield put(GetUserSubServices.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(GetUserSubServices.actions.loadFailure(e.message));
  }
}

export function* getUserSubServicesSagas() {
  yield takeEvery(GetUserSubServices.actionTypes.load, watchGetUserSubServices);
}

export function useGetUserSubServices() {
  const { loading, data, ...getUserSubServicesState } = useAppSelector(
    (state) => state.getUserSubServices,
  );
  const dispatch = useAppDispatch();

  const dispatchGetUserSubServices = useCallback(
    (data: { id: number | string }) => {
      dispatch(GetUserSubServices.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...getUserSubServicesState,
    dispatchGetUserSubServices,
    getUserSubServicesLoading: loading,
    getUserSubServicesData: data,
  };
}

export const {
  actionTypes: getUserSubServicesActionsTypes,
  actions: getUserSubServicesActions,
  reducer: getUserSubServicesReducer,
} = GetUserSubServices;
